<template>
  <div>
    <v-text-field v-if="getField(field)" type="text" :disabled="field ? field.DISABLED : false"
      :maxlength="field && field.MAXLEN ? field.MAXLEN : null" :rules="getValidators(field)" :label="getLabel(field)"
      :suffix="stripHtml(field.ADDHTML)" v-model.lazy="localValue" @change="handleInput"></v-text-field>
  </div>
</template>

<script>
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';

export default {
  name: 'aedTextField',
  mixins: [fieldMixin, helperMixin],
  props: {
    /**
     * Field object containing configuration details for the number input (e.g., formatting options).
     * @type {Object}
     */
    field: Object,

    /**
     * The current value of the number input field.
     * @type {string}
     */
    value: String,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },

  },
  mounted() {

    if (this.field && this.field.VALUE) {
      this.localValue = this.field.VALUE

    }

  },
  methods: {
    /**
     * Formats and validates the number input to include or exclude delimiters based on the configuration.
     * 
     * @param {string} inputValue - The raw number value inputted by the user.         
     */
    handleInput(newValue) {
      if (typeof newValue === 'string') {
     

        // Remove non-numeric characters at the end of the input
        let validValue = newValue.replace(/[^0-9.,]/g, ''); // remove all characters that are not numbers or separators
        //console.log('validValue', validValue);
        const separators = validValue.match(/[.,]/g) || [];

        while (separators.length > 1) { // remove extra separators
          const lastSeparatorIndex = validValue.lastIndexOf(separators.pop());
          validValue = validValue.slice(0, lastSeparatorIndex) + validValue.slice(lastSeparatorIndex + 1);
        }

        if (this.field.TYPE === 'N') { // remove all separators for 'N' type
          validValue = validValue.replace(/[.,]/g, '');
        }
        
        this.localValue = validValue;
        this.$emit('input', validValue);

      }
    },
  },
};
</script>